
import axios from "../../axios";
import { useQuery } from "react-query";
import { route } from "./routes";


export function useTotalProductCount() {
  return useQuery([route.TOTAL_PRODUCT_COUNT], async () => {
    const { data } = await axios.get(route.TOTAL_PRODUCT_COUNT);
    return data;
  })
}


export function useTotalLiveProductCount() {
  return useQuery([route.TOTAL_LIVE_PRODUCT_COUNT], async () => {
    const { data } = await axios.get(route.TOTAL_LIVE_PRODUCT_COUNT);
    return data;
  })
}


// total Riders
export function useTotalRiderCount() {
  return useQuery([route.TOTAL_RIDER_COUNT], async () => {
    const { data } = await axios.get(route.TOTAL_RIDER_COUNT);
    return data;
  })
}

// Available Riders
export function useTotalOnlineRiderCount() {
  return useQuery([route.TOTAL_ACTIVE_RIDER_COUNT], async () => {
    const { data } = await axios.get(route.TOTAL_ACTIVE_RIDER_COUNT);
    return data;
  })
}

// TOP_SELLING_PRODUCT
export function useTopSellingProduct() {
  return useQuery([route.TOP_SELLING_PRODUCT], async () => {
    const { data } = await axios.get(route.TOP_SELLING_PRODUCT);
    return data;
  })
}
// FEATURED_SELLING_PRODUCT
export function useFeaturedProduct() {
  return useQuery([route.FEATURED_SELLING_PRODUCT], async () => {
    const { data } = await axios.get(route.FEATURED_SELLING_PRODUCT);
    return data;
  })
}




// TOTAL USER
export function useTotalUser() {
  return useQuery([route.TOTAL_USER_COUNT], async () => {
    const { data } = await axios.get(route.TOTAL_USER_COUNT);
    return data;
  })
}


// TOTAL SELLER COUNT
export function useTotalSellerCount() {
  return useQuery([route.TOTAL_SELLER_COUNT], async () => {
    const { data } = await axios.get(route.TOTAL_SELLER_COUNT);
    return data;
  })
}

// TOTAL SELLER COUNT
export function useLastSavenDaysCustomer() {
  return useQuery([route.LAST_SEVEN_DAYS_CUSTOMER_LIST], async () => {
    const { data } = await axios.get(route.LAST_SEVEN_DAYS_CUSTOMER_LIST);
    return data;
  })
}


export function useOrderStatusListById({
  order_id
}) {
  return useQuery([route.ORDER_STATUS_LIST_BY_ID, order_id], async () => {
    const { data } = await axios.get(route.ORDER_STATUS_LIST_BY_ID, {
      params: {
        order_id
      }
    });
    return data;
  })
}

